import { mutation_keys } from "../mutations";

/**
 * Token action keys
 * @type {import("../types/actions/token").TokenActionKeys}
 */
const token_action_keys = {
    "SET": "TOKEN/SET",
    "REMOVE": "TOKEN/REMOVE"
}

/**
 * User specific actions.
 * @type {import("../types/actions/token").TokenActions}
 */
const token_actions = {

    /** Setting authenticated user token. */
    [token_action_keys.SET]: ({ commit }, token) => commit(mutation_keys.token.SET, token),

    /** Removing authenticated user token. */
    [token_action_keys.REMOVE]: ({ commit }) => commit(mutation_keys.token.SET, null)
};

export { token_action_keys };

export default token_actions;